import { useSelector } from 'react-redux';
import { useLocalStorage } from 'react-use';

import { getUserID } from '@app/store/user/user/selectors';

interface CompositeOrdering<T = string> {
  order: 'asc' | 'desc';
  orderBy: T;
}

type OrderingsState = CompositeOrdering<'title' | 'createdAt' | 'updatedAt'>;

const initialValue: OrderingsState = {
  order: 'desc',
  orderBy: 'updatedAt',
};

const useTemplateOrdering = () => {
  const userId = useSelector(getUserID);
  const [localStorageOrderings, setOrderingsStorage] = useLocalStorage<OrderingsState>(
    `template-orderings-${userId}-v1`,
    initialValue
  );

  const orderings = localStorageOrderings || initialValue;

  return {
    ordering: orderings,
    setOrdering: setOrderingsStorage,
    initOrdering: () => {
      setOrderingsStorage(initialValue);
    },
  };
};

export default useTemplateOrdering;
